import React from 'react'
import { observer } from 'mobx-react'
import ButtonList from '../../generic/ButtonList'
import { Box } from '../../generic/Box'
import Title from '../../generic/Title'

const EnvironmentList = observer(props => {
  const { formStore } = props
  const buttons = formStore.state.environments.map(data => {
    return {
      text: data,
      onClick: () => formStore.setSelectedEnvironment(data),
      styleClass: 'is-info',
      isActive: data === formStore.state.selectedEnvironment
    }
  })
  return (
    <Box>
      <Title>Ambiente</Title>
      <ButtonList buttons={buttons} />
    </Box>
  )
})

export default EnvironmentList



// WEBPACK FOOTER //
// ./src/components/dashboard/products/EnvironmentList.js